import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-dark-900 border-t border-dark-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center space-x-2">
              <img
                src="/images/logo.png"
                alt="Synapso"
                className="w-12 h-12 rounded-xl object-contain"
              />
              <span className="text-xl font-bold text-white">Synapso</span>
            </Link>
            <p className="text-dark-400 text-sm">
              Nejlepší online příprava na&nbsp;přijímačky na&nbsp;lékařskou fakultu v&nbsp;Česku.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Rychlé odkazy</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-dark-400 hover:text-white transition-colors text-sm">
                  Domů
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-dark-400 hover:text-white transition-colors text-sm">
                  Ceník
                </Link>
              </li>
              <li>
                <Link to="/jak-to-funguje" className="text-dark-400 hover:text-white transition-colors text-sm">
                  Jak to funguje
                </Link>
              </li>
              <li>
                <Link to="/o-nas" className="text-dark-400 hover:text-white transition-colors text-sm">
                  O nás
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Právní</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-dark-400 hover:text-white transition-colors text-sm">
                  Podmínky použití
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-dark-400 hover:text-white transition-colors text-sm">
                  Ochrana osobních údajů
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="text-dark-400 hover:text-white transition-colors text-sm">
                  Cookies
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Kontakt</h3>
            <ul className="space-y-2">
              <li className="flex items-center space-x-2 text-dark-400 text-sm">
                <Mail size={16} />
                <a href="mailto:info@synapso.cz" className="hover:text-white transition-colors">
                  info@synapso.cz
                </a>
              </li>
              <li className="flex items-center space-x-2 text-dark-400 text-sm">
                <Phone size={16} />
                <a href="tel:+420602708012" className="hover:text-white transition-colors">
                  +420 602 708 012
                </a>
              </li>
              <li className="flex items-center space-x-2 text-dark-400 text-sm">
                <MapPin size={16} />
                <span>Česká republika</span>
              </li>
              <li className="text-dark-400 text-sm">
                <a href="https://naklol.net" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                  Nakladatelství
                </a>
              </li>
              <li className="text-dark-400 text-sm">
                <a href="https://www.nakladatelstviolomouc.store" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                  Eshop
                </a>
              </li>
              <li className="text-dark-400 text-sm">
                <a href="https://bookitoo.cz" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                  Bookitoo.cz
                </a>
              </li>
            </ul>
            <div className="flex space-x-4 mt-4">
              <a
                href="https://www.facebook.com/nakladatelstviolomouc"
                target="_blank"
                rel="noopener noreferrer"
                className="text-dark-400 hover:text-white transition-colors"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://www.instagram.com/nakladatelstvi/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-dark-400 hover:text-white transition-colors"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-dark-800 text-center text-dark-500 text-sm">
          <p>&copy; {new Date().getFullYear()} Synapso. Všechna práva vyhrazena.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
